import React from "react"
import useServiceWorkerUpdate from "shared/hooks/useServiceWorkerUpdate"
import css from "./UpdateBanner.module.scss"

export default function UpdateBanner() {
  const { updateAvailable, reloadForUpdate } = useServiceWorkerUpdate()

  if (!updateAvailable) return null

  return (
    <div className={css.banner}>
      <span>A new version is ready</span>
      <button type="button" className={css.reload} onClick={reloadForUpdate}>
        Reload
      </button>
    </div>
  )
}
